import React from 'react'
import { NextPage } from 'next'
import { getQueryParam } from 'lib'
import { getSEOServersideProps, PagePropsWrapper } from 'lib/routing/nextPageUtils'
import { StandardLayout } from 'shared/layout/StandardLayout'
import { getTerms } from 'services/ContentfulService/hooks/term'
import { GlossaryPage, Props } from 'experiences/learn/glossary/Glossary'
import { FALLBACK_KEY, filterTerms, getValidPages, sortTerms } from 'experiences/learn/glossary/utils'

const Glossary: NextPage<PagePropsWrapper<Props>> = ({ metaTags, pageProps }) => (
	<StandardLayout metaTags={metaTags}>
		<GlossaryPage page={pageProps.page} terms={pageProps.terms} validPages={pageProps.validPages} />
	</StandardLayout>
)

export const getServerSideProps = getSEOServersideProps<Props>(
	async ctx => {
		const { query } = ctx
		const page = query.page && getQueryParam(query.page)[0]
		const terms = await getTerms({ constraints: [] })

		return {
			page,
			terms: filterTerms(terms, page || FALLBACK_KEY).sort(sortTerms),
			validPages: getValidPages(terms)
		}
	},
	(tags, props) => {
		const { page } = props

		if (page) {
			if (page != 'A') {
				// Hack until we move off A being default
				tags.url = tags.url.includes('?page') ? tags.url : `${tags.url}?page=${page}`
			}
			tags.title = `Terms Beginning With '${page.toUpperCase()}' | Fiona`
		}
		return tags
	}
)

export default Glossary
